<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 78 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M39 0L0 66H78L39 0ZM39 1.96568L1.75245 65H76.2476L39 1.96568Z"
      fill="url(#paint0_linear_2893_15683)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2893_15683"
        x1="78"
        y1="66"
        x2="21"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#80B7FF" />
        <stop offset="1" stop-color="#80B7FF" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
import { colors } from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 78 },
    height: { type: [Number, String], default: 66 },
    color: { type: String, default: colors.callIcon },
  },
};
</script>